<template>
  <div class="image-content">
    <div v-if="imageExists" class="content">
      <div class="image-box">
        <!-- thumbnail -->
        <div class="image-head">
          <div class="label-wrapper">
            <div class="image-wrapper">
              <img :src="attrs.src" alt="thumbnail">
            </div>
            <!-- thumbnail -->
          </div>
          <div class="image-head-info">
            <div
              class="button-box"
            >
              <button
                @click="isShowImageDetailEditor = true"
                :class="{disabled: isExternalImage}"
              >
                編集
              </button>
              <portal v-if="isShowImageDetailEditor" to="modal1">
                <image-detail-editor-popup
                  :imageAttr="attrs4ImageDetailEditor"
                  @reflectImage="reflectImage"
                  @close="isShowImageDetailEditor = false"
                />
              </portal>
              <button @click="isShowImageManager = true">画像変更</button>
            </div><!-- .button-box -->
            <div class="image-detail-wrapper">
              <ul class="detail-list">
                <li class="detail-list-group">
                  <ul>
                    <li class="detail-list-item"><span>名前</span>：{{ attrs['data-filename'] }}</li>
                  </ul>
                </li>
                <li class="detail-list-group">
                  <ul>
                    <li class="detail-list-item"><span>サイズ</span>：{{ filesize }}</li>
                    <li class="detail-list-item"><span>横 × 縦</span>：{{ displayWidth }}px × {{ displayHeight }}px</li>
                  </ul>
                  <div
                    v-if="isExternalImage"
                    class="image-re-get-button"
                    @click="insertURL(true)"
                  >
                    <i class="fas fa-redo-alt"></i>
                  </div>
                </li>
              </ul>
            </div>
            <div class="detail-wrapper">
              <button
                class="detail"
                :class="{open: isOpenAll}"
                @click="toggleOpenDetail"
              >
                詳細設定
              </button>
            </div>
          </div><!-- .image-head-info -->
        </div><!-- .image-head -->
        <div
          class="image-detail"
          ref="imageDetail"
          :style="{height: height + 'px'}"
        >
          <fieldset class="edit-url">
            <label>参照URL</label>
            <span v-show="!focus.url" class="name">
              <span class="name-content">{{ attrs['data-external-url'] }}</span>
              <a @click="openEditInput('url')" @mousedown.stop>
                <i class="fas fa-pen"></i>
              </a>
              <a :href="attrs['data-external-url']" :class="{disabled: !isExternalImage}" @mousedown.stop target="_blank" rel="noopener noreferrer">
                <i class="fas fa-external-link-alt" ></i>
              </a>
            </span>
            <span v-show="focus.url">
              <div class="common-input">
                <input
                  type="text"
                  :value="attrs['data-external-url']"
                  @change="insertURL(false)"
                  @keypress.enter="$event.target.blur"
                  @blur="saveAndCloseEditInput('url')"
                  ref="urlInput"
                />
              </div>
            </span>
          </fieldset>
          <!-- 画像サイズ コードパーツは非表示 -->
          <image-content-display-percent
            v-if="!isCode"
            :ids="ids"
            :displayPercent="attrs['data-display-percent'] || 100"
          />
          <!-- alt-->
          <fieldset class="edit-alt">
            <label>altテキスト</label>
            <span v-show="!focus.alt" class="name">
              <span class="name-content">
                {{ $utils.string.sanitizeDecode(attrs.alt) }}
              </span>
              <a @click="openEditInput('alt')" @mousedown.stop>
                <i class="fas fa-pen"></i>
              </a>
            </span>
            <span v-show="focus.alt">
              <div class="common-input">
                <input
                  type="text"
                  :value="$utils.string.sanitizeDecode(attrs.alt)"
                  @change="insertAlt($event)"
                  @keypress.enter="$event.target.blur"
                  @blur="saveAndCloseEditInput('alt')"
                  ref="altInput"
                />
              </div>
            </span>
          </fieldset>
          <!-- alt-->
          <!-- link-->
          <edit-link
            v-if="!isCode"
            :ids="ids"
            :attrs="attrs"
            :partsContainerType="partsContainerType"
          />
        </div>
      </div><!-- .image-box -->
    </div><!-- .content -->
    <div class="noimage image-box" v-else><!-- 画像がセットされていない時 -->
      <span><img src="@/assets/emptyimage.png" alt="empty thumbnail" :width="100" :height="100"></span>
      <button @click="isShowUploadPopup = true" class="add">新規追加</button>
      <button @click="isShowImageManager = true" class="select">画像選択</button>
    </div>
    <div class="loading" v-if="isLoading">
      <div class="spinner">
        <span>Loading...</span>
      </div>
    </div>
    <portal v-if="isShowUploadPopup" to="modal1">
      <upload-popup
        :ids="ids"
        :isCallByEditor="true"
        :isShowTabPanel="true"
        @reflectImage="reflectImage"
        @close="isShowUploadPopup = false"
      />
    </portal>
    <portal v-if="isShowImageManager" to="modal1">
      <image-manager-popup
        @reflectImage="reflectImage"
        @close="isShowImageManager = false"
      />
    </portal>
  </div>
</template>

<script>
import EditLink from '@/components/Content/Palette/EditPartDesign/Layouts/EditLink'
import ImageManagerPopup from '@/components/ImageManager/ImageManagerPopup'
import UploadPopup from '@/components/ImageManager/UploadPopup'
import ImageDetailEditorPopup from '@/components/Util/ImageDetailEditor/ImageDetailPopup'
import { validateImageUrl, validateImageAlt } from '@/utils/String'
import ImageContentDisplayPercent from '@/components/Content/Palette/EditPartDesign/Editor/Image/ImageContentDisplayPercent'

const IMAGE_DETAIL_HEIGHT = 110
const CODE_IMAGE_DETAIL_HEIGHT = 50

const initialData = () => {
  return {
    focus: {
      alt: false,
      url: false,
    },
    isShowImageManager: false,
    isShowUploadPopup: false,
    isShowImageDetailEditor: false,
    isShowExtraBorderOption: false,
    isOpenAll: false,
    heightAll: 300,
    height: 0,
    displayPercent: 0,
    isLoading: false,
  }
}

export default {
  props: [
    'styles',
    'attrs',
    'ids',
    'partsContainerType',
  ],
  components: {
    EditLink,
    ImageManagerPopup,
    ImageDetailEditorPopup,
    UploadPopup,
    ImageContentDisplayPercent,
  },
  data () {
    return initialData()
  },
  computed: {
    imageExists () {
      return this.attrs && this.attrs['data-key']
    },
    attrs4ImageDetailEditor () {
      const key = this.attrs['data-key']
      if (!key) return null
      const contentImage = this.$store.state.contentImages[key]
      if (!contentImage) return null
      return {
        ...this.attrs,
        'data-filetype': contentImage.type,
        'data-filesize': contentImage.filesize
      }
    },
    filesize () {
      const key = this.attrs['data-key']
      if (!key) return null
      const contentImage = this.$store.state.contentImages[key]
      if (!contentImage) return null
      return Math.ceil(contentImage.filesize / 1024).toLocaleString() + 'KB'
    },
    displayWidth () {
      if (!this.attrs['data-width']) return null
      return Number(this.attrs['data-width'].replace('px', '')).toLocaleString()
    },
    displayHeight () {
      if (!this.attrs['data-height']) return null
      return Number(this.attrs['data-height'].replace('px', '')).toLocaleString()
    },
    isExternalImage () {
      return this.attrs['data-external-url'] != null
    },
    isCode () {
      return this.partsContainerType === 'Code'
    },
  },
  created () {
    if (this.isCode) {
      this.heightAll = CODE_IMAGE_DETAIL_HEIGHT
    }
  },
  mounted () {
    this.initComponent()
  },
  methods: {
    initComponent () {
      // 初期値設定
      if (!this.styles || !this.attrs) return
      this.initToggle()
    },
    initToggle () {
      // 画像グループ以外の時は、詳細設定を開いた状態にしておく
      if (this.partsContainerType !== 'ImageGroup') this.toggleOpenDetail()
    },
    reflectImage (image) {
      const attrs = image.image
      const newAttrs = this.$utils.image.getImageAttrs({
        ...attrs,
        // 画像反映時、詳細エディタからの場合はaltそのまま、それ以外(イメージ管理/アップロードポップアップ)は上書き
        alt: image.isDetailEditor ? this.attrs.alt : attrs.alt,
      })
      if (this.isCode) {
        this.$emit('reflectCodeImage', newAttrs)
      } else {
        this.$store.dispatch('reflectImage', {
          ...this.ids,
          attrs: newAttrs,
        })
      }
    },
    toggleOpenDetail () {
      this.isOpenAll = !this.isOpenAll
      if (this.isOpenAll) {
        this.height = this.heightAll + IMAGE_DETAIL_HEIGHT
      } else {
        this.height = 0
      }
    },
    async insertURL (isCheckModified = false) {
      if (this.isLoading) return // 二度押し防止
      const urlInputElem = this.$refs.urlInput
      const errorMessages = [
        ...validateImageUrl(urlInputElem.value),
        ...validateImageAlt(this.attrs.alt)
      ]
      if (errorMessages.length > 0) return this.$store.commit('showErrorMessagePopup', errorMessages)
      this.isLoading = true

      const formData = new FormData()
      formData.append('url', this.$utils.string.b64Encode(urlInputElem.value))
      formData.append('tmpUuid', this.$store.state.contentTmpUuid)
      formData.append('contentId', this.$route.params.id)
      await this.$http({
        url: '/image/check_external_image',
        type: 'POST',
        params: formData,
      }).then(json => {
        this.isLoading = false
        if (json && json.status === 200) {
          const image = json.data.image
          if (isCheckModified && this.isImageModified(image)) {
            this.$store.commit(
              'showErrorMessagePopup',
              [
                '画像情報の変更を検知しました',
                'プレビューに反映させるには、ブラウザのキャッシュを削除して、編集画面の再読み込みをしてください',
              ]
            )
          }
          // 外部画像取得時、altは空にする
          const attrs = {
            ...image,
            filename: this.$utils.string.getStrippedImageFilename(image.filename),
            'data-external-url': image.url,
            alt: '',
          }
          this.reflectImage({
            image: attrs,
            isDetailEditor: false,
          })
          this.$store.commit('mergeContentImages', { [image.key]: image })
          this.$emit('close')
        }
      }).catch(() => {
        this.isLoading = false
      })
    },
    isImageModified (imageData) {
      const key = this.attrs['data-key']
      const contentImage = this.$store.state.contentImages[key]
      if (imageData.width !== contentImage.width || imageData.height !== contentImage.height || imageData.filesize !== contentImage.filesize) {
        return true
      }
      return false
    },
    openEditInput (target) {
      this.focus[target] = true
      if (this.$refs[`${target}Input`]) {
        this.$nextTick(() =>
          this.$refs[`${target}Input`].focus()
        )
      }
    },
    saveAndCloseEditInput (target) {
      this.focus[target] = false
    },
    insertAlt (event) {
      const errorMessages = validateImageAlt(event.target.value)
      if (errorMessages.length > 0) return this.$store.commit('showErrorMessagePopup', errorMessages)
      if (this.isCode) {
        this.$emit('reflectCodeImage', {
          alt: event.target.value,
          src: this.attrs.src // srcは必ず上書きされるので、変更がなくても渡す
        })
      } else {
        // alt テキストの HTML タグを無効にする
        this.$store.commit('updatePart', {
          ...this.ids,
          attrs: { alt: this.$utils.string.sanitizeEncode(event.target.value) }
        })
      }
      this.$emit('close')
    },
  },
  watch: {
    'ids.partsContainerId' () {
      Object.assign(this.$data, initialData())
      this.initComponent()
    },
  }
}
</script>

<style lang="scss" scoped>
.image-content {
  .image-box {
    padding: 30px 15px 20px;
    border-top: 1px solid #dbdbdb;
    background: #fff;
  }
  &:last-of-type .image-box {
    border-bottom: 1px solid #dbdbdb;
    margin-bottom: 20px;
  }
  // 画像がないとき
  .noimage {
    display: flex;
    align-items: center;
    span {
      display: block;
      width: 100px;
      height: 100px;
      background: #F8F8F8;
      margin-right: 20px;
      border-radius: 2px;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 50px;
        max-width: 100%;
        height: auto;
        vertical-align: bottom;
      }
    }
    button {
      width: 96px;
      height: 64px;
      white-space: nowrap;
      font-weight: 300;
      border-radius: 2px;
      transition: all 0.3s ease 0s;
      text-align: center;
      cursor: pointer;
      &:hover, &:active {
        background: #e4e4e4;
        transition: all 0.3s ease 0s;
        border-radius: 2px;
      }
      &::before {
        font-family: "Font Awesome 5 Free";
        display: block;
        text-align: center;
        content: '\f276';
        font-weight: 900;
      }
      &.add {
        &::before {
          content: '\f574';
        }
      }
      &.select {
        &::before {
          content: '\f276';
        }
      }
    }
  }
  .image-head {
    display: flex;
    align-items: center;
    .label-wrapper {
      position: relative;
    }
    .image-wrapper {
      position: relative;
      width: 100px;
      height: 100px;
      background: #f8f8f8;
      border-radius: 2px;
      overflow: hidden;
      margin-right: 20px;
      img {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        margin: auto;
        max-width: 100%;
        max-height: 100%;
        width: auto;
        height: auto;
      }
    }
    .image-head-info {
      width: 100%;
      .button-box {
        button {
          width: 96px;
          height: 64px;
          white-space: nowrap;
          font-weight: 300;
          border-radius: 2px;
          transition: all 0.3s ease 0s;
          text-align: center;
          line-height: 1.6;
          cursor: pointer;
          &.disabled {
            pointer-events: none;
            background-color: #d8d8d8;
            color: #ababac
          }
          &:hover, &:active {
            background: #e4e4e4;
            transition: all 0.3s ease 0s;
            border-radius: 2px;
          }
          &::before {
            font-family: "Font Awesome 5 Free";
            display: block;
            text-align: center;
            font-weight: 900;
          }
          &:nth-of-type(1)::before {
            content: '\f574';
          }
          &:nth-of-type(2)::before {
            content: '\f276';
          }
        }
      }
    }
    .image-detail-wrapper {
      margin-top: 10px;
      display: flex;
      justify-content: space-between;
      width: 100%;
      .detail-list {
        flex-direction: column;
        font-size: 14px;
        color: rgba($baseFontColor, 0.6);
        li.detail-list-group {
          width: 250px;
          display: flex;
          justify-content: flex-start;
          > ul {
            display: inline;
            max-width: 100%;
          }
          .detail-list-item {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            list-style: none;
          }
          .image-re-get-button {
            color: rgba(35, 24, 21, 0.75);
            cursor: pointer;
            display: flex;
            align-items: center;
            padding: 0 15px;
            justify-content: center;
          }
          span {
            display: inline-block;
            width: 46px;
          }
        }
      }
    }
  }
  .detail-wrapper {
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    .detail {
      display: flex;
      align-items: center;
      position: relative;
      margin-top: 5px;
      cursor: pointer;
      &:hover {
        opacity: 0.6;
      }
      &::before {
        font-family: "Font Awesome 5 Free";
        font-weight: 900;
        content: '\f107';
        position: absolute;
        left: -15px;
        transition: all 0.1s ease 0s;
      }
      &.open::before {
        transform: rotate(180deg);
      }
    }
  }
  .image-detail {
    transition: all 0.3s ease 0s;
    overflow: hidden;
    .edit-alt, .edit-url {
      font-size: 14px;
      padding: 5px 0 5px 0;
      .name {
        display: flex;
        .name-content {
          width: 340px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          background-color: #eeeeee;
          cursor: text;
        }
        a {
          padding-left: 7px;
          padding-right: 7px;
          background-color: #eeeeee;
          cursor: pointer;
          &.disabled {
            color: #d8d8d8;
            cursor: auto;
          }
        }
      }
      .common-input {
        width: 340px;
      }
      label {
        display: block;
        margin:10px 0 0 0;
        &::before {
          padding-right: 8px;
          font-size: 14px;
          font-family: "Font Awesome 5 Free";
        }
      }
    }
  }
}
.editor-fields {
  display: flex;
  align-items: center;
  margin-bottom: 0;
  padding-bottom: 10px;
  &.image-size {
    padding: 20px 0 10px;
  }
  fieldset {
    legend {
      font-size: 14px;
      margin-bottom: 5px;
    }
    .flex-center {
      display: flex;
      align-items: center;
      span {
        font-size: 12px;
        margin: 0 5px;
      }
      input {
        width: 250px;
      }
    }
  }
}

.loading {
  position: absolute;
  content: '';
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.9);
  top: 0;
  left: 0;
}

</style>
